import { render, staticRenderFns } from "./courier-view.vue?vue&type=template&id=76f67815&"
import script from "./courier-view.vue?vue&type=script&lang=js&"
export * from "./courier-view.vue?vue&type=script&lang=js&"
import style0 from "./courier-view.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports